var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-checkbox',{on:{"input":function($event){return _vm.saveChange($event)}},model:{value:(_vm.enabled),callback:function ($$v) {_vm.enabled=$$v},expression:"enabled"}},[_vm._v(" "+_vm._s(_vm.alert)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }